import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { translate } from 'react-i18next';
import { Grid, Form, Button } from 'semantic-ui-react';

import isAlpha from 'validator/lib/isAlpha';
import isEmpty from 'validator/lib/isEmpty';
import getUrlParameter from '../utils/getUrlParameter';
import { apiEndpoint } from '../utils/env';

class Reset extends Component {
  constructor() {
    super();
    this.state = {
      pass: {
        value: '',
        typed: false,
      },
      name: {
        value: '',
        typed: false,
      },
      surname: {
        value: '',
        typed: false,
      },
    };
    this.hasTypedPass = false;
    this.updateData = this.updateData.bind(this);
    this.reset = this.reset.bind(this);
  }

  reset(e) {
    e.preventDefault();

    const { name, surname, pass } = this.state;

    fetch(`${apiEndpoint}/users/auth/reset`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      mode: 'cors',
      body: JSON.stringify({
        data: {
          type: 'users',
          attributes: {
            password: pass.value,
            email: getUrlParameter('email'),
            firstName: name.value,
            lastName: surname.value,
          },
        },
      }),
    })
      .then(res => res.json())
      .then((response) => {
        console.log(response);
        this.props.history.replace('/login');
      })
      .catch((err) => {
        console.log(err);
      });
  }

  updateData(e, { name, value }) {
    this.setState({ [name]: { value, typed: true } });
  }

  render() {
    const { t } = this.props;
    const { name, surname, pass } = this.state;
    const nameValid = isAlpha(name.value) && !isEmpty(name.value);
    const surnameValid = isAlpha(surname.value) && !isEmpty(surname.value);
    const passValid = !isEmpty(pass.value);
    const canSubmit = nameValid && surnameValid && passValid && name.typed && surname.typed && pass.typed;

    return (
      <Grid>
        <Grid.Row columns={3}>
          <Grid.Column />
          <Grid.Column>
            <Form>
              <Form.Field required>
                <label>{t('common.firstname')}</label>
                <Form.Input
                  placeholder={t('common.firstname')}
                  name="name"
                  onChange={this.updateData}
                  error={!nameValid && name.typed}
                />
              </Form.Field>
              <Form.Field required>
                <label>{t('common.lastname')}</label>
                <Form.Input
                  placeholder={t('common.lastname')}
                  name="surname"
                  onChange={this.updateData}
                  error={!surnameValid && surname.typed}
                />
              </Form.Field>
              <Form.Field required>
                <label>{t('userForm.newpassword')}</label>
                <Form.Input
                  placeholder={t('userForm.newpassword')}
                  type="password"
                  name="pass"
                  onChange={this.updateData}
                  error={!passValid && pass.typed}
                />
              </Form.Field>
              <Button primary disabled={!canSubmit} onClick={this.reset}>
                {t('userForm.setprofile')}
              </Button>
            </Form>
          </Grid.Column>
          <Grid.Column />
        </Grid.Row>
        {/* <button type="button" onClick={this.reset}>
          reset
        </button> */}
      </Grid>
    );
  }
}

Reset.propTypes = {
  t: PropTypes.func.isRequired,
  history: PropTypes.shape({
    replace: PropTypes.func.isRequired,
  }).isRequired,
};

export default translate()(Reset);



// WEBPACK FOOTER //
// ./src/components/Reset.js